import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import type { Pagination } from '../table.component';

@Pipe({
  pure: true,
  name: 'rtTablePagination',
  standalone: true,
})
export class TablePaginationPipe implements PipeTransform {
  public transform<T>(dataTableRowsMapped: T[], pagination?: Pagination): T[] {
    return pagination
      ? dataTableRowsMapped.slice(
          (pagination.page - 1) * pagination.limit,
          (pagination.page - 1) * pagination.limit + pagination.limit,
        )
      : dataTableRowsMapped;
  }
}
